import React, {
  useCallback,
}                      from 'react';
import styled, { css } from 'styled-components';
import MaskedInput     from 'react-text-mask';
import {
  FormControl as MuiFormControl,
  InputLabel,
  OutlinedInput,
  OutlinedInputProps,
}                      from '@material-ui/core';

const PHONE_INPUT_MASK = [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
const PHONE_INPUT_PLACEHOLDER_CHAR = '\u2000';

interface IPhoneInputProps extends OutlinedInputProps {
  form  : {
    setFieldValue: (name: string, value: any) => void;
  };
  field     : any;
  id        : string;
  label?    : string;
  margin?   : 'dense';
  gray      : boolean;
  fullWidth : boolean;
}

const FormControl = styled(MuiFormControl)`
  && {
    margin-top: 0;

    ${({ gray }: any): any => !gray && css`
      margin-top    : 15px;
      margin-bottom : 4px;
    `};

    ${({ gray }: any): any => gray && css`
      fieldset {
        border-color: #DDDDDD;
      }
    `};

    input {
      color: ${({ gray, theme: { textColor } }: any): string => (gray ? textColor.black : textColor.gray)};

      ${({ gray }: any): any => gray && css`
        padding          : 6px 14px 7px ${({ labelicon }: any): string => (labelicon ? '20px' : '14px')};
        background-color : #F5F5F5;
      `};
    }
  }
` as any;

interface ITextMaskCustomProps {
  inputRef: (ref: HTMLInputElement | null) => void;
}

const TextMaskCustom: React.FC<ITextMaskCustomProps> = (
  props: ITextMaskCustomProps,
): JSX.Element => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref             = {(ref: any): any => inputRef(ref ? ref.inputElement : null)}
      mask            = {PHONE_INPUT_MASK}
      placeholderChar = {PHONE_INPUT_PLACEHOLDER_CHAR}
    />
  );
};

export const PhoneInput: React.FC<IPhoneInputProps> = ({
  form: {
    setFieldValue,
  },
  field,
  id,
  label,
  margin,
  gray,
  fullWidth,
  ...props
}: IPhoneInputProps): JSX.Element => {
  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>): void => {
      const nonDigitRegex = new RegExp('[^\\d\\+]', 'g');
      const value = event.target.value.replace(nonDigitRegex, '');

      setFieldValue(field.name, value);
    },
    [field.name, setFieldValue],
  );

  return (
    <FormControl
      variant   = "outlined"
      gray      = {gray}
      margin    = {margin}
      fullWidth = {fullWidth}
    >
      {label && (
        <InputLabel
          htmlFor = {id}
          margin  = {margin}
        >
          {label}
        </InputLabel>
      )}

      <OutlinedInput
        {...field}
        {...props}
        id             = {id}
        margin         = {margin}
        fullWidth      = {fullWidth}
        onChange       = {onChange}
        inputComponent = {TextMaskCustom}
      />
    </FormControl>
  );
};

PhoneInput.defaultProps = {
  gray        : false,
  margin      : 'dense',
  placeholder : 'Phone No',
  fullWidth   : true,
};
